import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import MenuItem from "@/types/MenuItem";
import * as _ from 'lodash';
import { Getter } from "vuex-class";
import AppBar from "@/components/AppBar.vue";
let Home = class Home extends Vue {
    IsAuthenticated;
    get menuItems() {
        let retVar = [];
        if (this.$router.options.routes != null) {
            this.$router.options.routes.forEach(route => {
                let routeMeta = route.meta;
                if (routeMeta) {
                    if (routeMeta.showInMenu && routeMeta.requiresAuth == this.IsAuthenticated) {
                        retVar.push(new MenuItem(route.name ?? "", routeMeta.menuIcon, route.path, routeMeta.menuOrder, routeMeta.menuTranslation));
                    }
                }
            });
            retVar = _.orderBy(retVar, ['order'], ['asc']);
        }
        return retVar;
    }
};
__decorate([
    Getter
], Home.prototype, "IsAuthenticated", void 0);
Home = __decorate([
    Component({
        components: {
            AppBar,
        },
    })
], Home);
export default Home;
